/** What the offer-stage colour picker shows while a stage has no colour of its
 * own. `<input type="color">` accepts only a #rrggbb value, so this cannot be a
 * theme token; it is saved only if the admin actually picks a colour. */
export const STAGE_COLOR_PICKER_DEFAULT = "#5a647a";

/** Value for the colour picker: the stage's own colour when it is #rrggbb,
 * otherwise the default above. */
export function stageColorPickerValue(color: string | null): string {
  return color && /^#[0-9a-f]{6}$/i.test(color) ? color : STAGE_COLOR_PICKER_DEFAULT;
}
